import { useEditor } from "src/components/Renderer/RendererProvider";
import { useInitialValue } from "src/hooks/useInitialValue";
import { useSendAnalyticsEvent } from "src/libs/analytics-lib";
import type { RenderConfigClip } from "@memento/types/render-config";

/**
 * Tracks changes to a clip's settings and fires an analytics event when the
 * organizer clicks "Done" after making a change.
 */
export function useEditorClipSettingsDoneEvent(clip: RenderConfigClip): {
  onClickDone: () => void;
} {
  const { card, editor } = useEditor();
  const { sendAnalyticsEvent } = useSendAnalyticsEvent();

  const getSnapshotSignature = () =>
    JSON.stringify(editor.clips.find((c) => c.segmentId === clip.segmentId));

  const initialSnapshot = useInitialValue(() => getSnapshotSignature());

  function onClickDone() {
    const currentSnapshot = getSnapshotSignature();

    // the settings didn't change so we don't need to send an analytics event
    if (currentSnapshot === initialSnapshot) {
      return;
    }

    sendAnalyticsEvent({
      event: "EditorClipSettingsDone",
      data: { cardId: card.cardId },
    });
  }

  return { onClickDone };
}
